// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.customer-quotation-container {
    padding: 0 40px 40px;
    background-color: #fff;
}

.customer-quotation-container .breadcrumb {
    background-color: #f5f5f5;
    padding: 21px 82px;
    margin: 0 -40px 30px;
    color: #717171;
}

.page-header {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 30px;
}

.page-title-bar {
    width: 5px;
    height: 24px;
    background-color: #e84118;
}

.page-header h2 {
    font-size: 24px;
    font-weight: bold;
    margin: 0;
}

.search-section {
    border-top: 2px solid #222;
    padding-top: 20px;
}

.search-row {
    display: flex;
    align-items: center;
    gap: 20px;
    border-bottom: 1px solid #eee;
    padding: 15px 0;
}

.search-row label {
    font-weight: bold;
    width: 120px;
    text-align: left;
    padding-left: 20px;
}

.search-row input[type="text"] {
    border: 1px solid #ccc;
    border-radius: 5px;
    padding: 15px;
    flex-grow: 1;
    max-width: 670px;
}

.search-row .date-input {
    width: 150px;
    flex-grow: 0;
    border: 1px solid #ccc;
    border-radius: 5px;
    padding: 15px;
}

.admin-quotation-image {
    width: 40px !important;
    height: 40px !important;
    object-fit: cover;
    border-radius: 4px;
    border: 1px solid #dee2e6;
    flex-shrink: 0;
}

.product-text-info {
    flex: 1 1;
    min-width: 0;
    text-align: left;
}

.product-text-info span {
    font-size: 14px;
    font-weight: 500;
    color: #333;
    line-height: 1.4;
    word-break: break-word;
}
.search-row .date-buttons {
    display: flex;
    gap: 5px;
}
.search-row .date-buttons button {
    padding: 10px 15px;
    border: 1px solid #ccc;
    background-color: #f1f1f1;
    border-radius: 5px;
    cursor: pointer;
}
.search-row .date-buttons button.active {
    border-color: #e84118;
    color: #e84118;
    background-color: white;
}
.checkbox-group {
    display: flex;
    gap: 20px;
    align-items: center;
}
.checkbox-group label {
    width: auto;
    font-weight: normal;
    display: flex;
    align-items: center;
    gap: 5px;
}

.status-buttons {
    display: flex;
    gap: 10px;
    align-items: center;
}

.status-buttons button {
    padding: 8px 16px;
    border: 1px solid #ccc;
    background-color: #f8f9fa;
    border-radius: 5px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    transition: all 0.3s ease;
}

.status-buttons button.active {
    background-color: #E84100;
    color: white;
    border-color: #E84100;
}

.status-buttons button:hover {
    background-color: #e9ecef;
    border-color: #adb5bd;
}

.status-buttons button.active:hover {
    background-color: #d73502;
    border-color: #d73502;
}

.product-info-cell {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    text-align: left;
    padding: 10px;
    background-color: #f8f9fa;
    border-radius: 6px;
    border: 1px solid #dee2e6;
    gap: 15px;
}

.search-actions {
    display: flex;
    justify-content: center;
    gap: 20px;
    margin: 30px 0;
}
.search-actions button {
    width: 350px;
    padding: 15px;
    border-radius: 5px;
    font-size: 18px;
    cursor: pointer;
}
.btn-search {
    background-color: #e84118;
    color: white;
    border: none;
}
.btn-reset {
    background-color: white;
    color: #222;
    border: 1px solid #222;
}

.quotation-list-container {
    margin-top: 40px;
}

.list-header {
    margin-bottom: 15px;
}

.list-header span {
    font-weight: bold;
}

.quotation-table {
    width: 100%;
    border-collapse: collapse;
    border-top: 2px solid #222;
}

.quotation-table th, .quotation-table td {
    padding: 20px;
    text-align: center;
    border-bottom: 1px solid #eee;
}

.quotation-table th {
    background-color: #f9f9f9;
}

.quotation-table .product-cell {
    display: flex;
    align-items: center;
    gap: 15px;
    justify-content: flex-start;
    text-align: left;
}

.quotation-table .product-cell img {
    width: 78px;
    height: 42px;
}

.quotation-table {
    width: 100%;
    border-collapse: collapse;
    border-top: 2px solid #333;
    cursor: pointer;
}

.quotation-table th,
.quotation-table td {
    text-align: center;
    padding: 15px 10px;
    border-bottom: 1px solid #ddd;
    vertical-align: middle;
}

.quotation-table th {
    font-weight: bold;
    background-color: #f8f9fa;
}

.quotation-table th:nth-child(1) { width: 60px; }
.quotation-table th:nth-child(2) { width: 200px; }
.quotation-table th:nth-child(3) { width: auto; min-width: 350px; }
.quotation-table th:nth-child(4) { width: 100px; }
.quotation-table th:nth-child(5) { width: 120px; }

.quotation-table tr:hover {
    background-color: #f8f9fa;
}

.page-actions {
    display: flex;
    justify-content: center;
    gap: 20px;
    margin-top: 50px;
    border-top: 1px solid #222;
    padding-top: 40px;
}

.page-actions button {
    width: 350px;
    padding: 15px;
    border-radius: 5px;
    font-size: 18px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
}

.btn-secondary {
    background-color: #222;
    color: white;
    border: none;
}

.btn-primary {
    background-color: #e84118;
    color: white;
    border: none;
}

.arrow-icon {
    font-size: 16px;
    font-weight: bold;
}

/* Tablet and smaller devices */
@media (max-width: 1024px) {
    .search-row {
        flex-direction: column;
        align-items: stretch;
        gap: 10px;
    }
    .search-row label {
        width: auto;
        padding-left: 0;
    }
    .search-actions, .page-actions {
        flex-direction: column;
    }
    .search-actions button, .page-actions button {
        width: 100%;
    }
}

/* Mobile devices */
@media (max-width: 768px) {
    .quotation-table thead {
        display: none;
    }

    .quotation-table, .quotation-table tbody, .quotation-table tr, .quotation-table td {
        display: block;
        width: 100%;
    }

    .quotation-table tr {
        margin-bottom: 15px;
        border: 1px solid #ddd;
        border-radius: 5px;
        overflow: hidden;
    }

    .quotation-table td {
        text-align: right;
        padding-left: 50%;
        position: relative;
    }

    .quotation-table td::before {
        content: attr(data-label);
        position: absolute;
        left: 15px;
        width: calc(50% - 30px);
        padding-right: 10px;
        white-space: nowrap;
        text-align: left;
        font-weight: bold;
    }
    
    .quotation-table .product-cell {
        justify-content: flex-end;
    }

    .quotation-table .product-cell img {
        display: none; /* Hide image on smallest screens to save space */
    }
} `, "",{"version":3,"sources":["webpack://./src/admin/css/CustomerQuotationPage.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;IACpB,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,oBAAoB;IACpB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,SAAS;AACb;;AAEA;IACI,0BAA0B;IAC1B,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,sBAAsB;AAC1B;AACA;IACI,aAAa;IACb,QAAQ;AACZ;AACA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,qBAAqB;IACrB,cAAc;IACd,uBAAuB;AAC3B;AACA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,gBAAgB;IAChB,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;IACzB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,cAAc;AAClB;AACA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,eAAe;AACnB;AACA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;AAChB;AACA;IACI,uBAAuB;IACvB,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,0BAA0B;IAC1B,eAAe;AACnB;;AAEA;;IAEI,kBAAkB;IAClB,kBAAkB;IAClB,6BAA6B;IAC7B,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA,mCAAmC,WAAW,EAAE;AAChD,mCAAmC,YAAY,EAAE;AACjD,mCAAmC,WAAW,EAAE,gBAAgB,EAAE;AAClE,mCAAmC,YAAY,EAAE;AACjD,mCAAmC,YAAY,EAAE;;AAEjD;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,gBAAgB;IAChB,0BAA0B;IAC1B,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,sBAAsB;IACtB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA,+BAA+B;AAC/B;IACI;QACI,sBAAsB;QACtB,oBAAoB;QACpB,SAAS;IACb;IACA;QACI,WAAW;QACX,eAAe;IACnB;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,WAAW;IACf;AACJ;;AAEA,mBAAmB;AACnB;IACI;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;QACd,WAAW;IACf;;IAEA;QACI,mBAAmB;QACnB,sBAAsB;QACtB,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;QACjB,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,yBAAyB;QACzB,kBAAkB;QAClB,UAAU;QACV,uBAAuB;QACvB,mBAAmB;QACnB,mBAAmB;QACnB,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,aAAa,EAAE,iDAAiD;IACpE;AACJ","sourcesContent":[".customer-quotation-container {\n    padding: 0 40px 40px;\n    background-color: #fff;\n}\n\n.customer-quotation-container .breadcrumb {\n    background-color: #f5f5f5;\n    padding: 21px 82px;\n    margin: 0 -40px 30px;\n    color: #717171;\n}\n\n.page-header {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    margin-bottom: 30px;\n}\n\n.page-title-bar {\n    width: 5px;\n    height: 24px;\n    background-color: #e84118;\n}\n\n.page-header h2 {\n    font-size: 24px;\n    font-weight: bold;\n    margin: 0;\n}\n\n.search-section {\n    border-top: 2px solid #222;\n    padding-top: 20px;\n}\n\n.search-row {\n    display: flex;\n    align-items: center;\n    gap: 20px;\n    border-bottom: 1px solid #eee;\n    padding: 15px 0;\n}\n\n.search-row label {\n    font-weight: bold;\n    width: 120px;\n    text-align: left;\n    padding-left: 20px;\n}\n\n.search-row input[type=\"text\"] {\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    padding: 15px;\n    flex-grow: 1;\n    max-width: 670px;\n}\n\n.search-row .date-input {\n    width: 150px;\n    flex-grow: 0;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    padding: 15px;\n}\n\n.admin-quotation-image {\n    width: 40px !important;\n    height: 40px !important;\n    object-fit: cover;\n    border-radius: 4px;\n    border: 1px solid #dee2e6;\n    flex-shrink: 0;\n}\n\n.product-text-info {\n    flex: 1;\n    min-width: 0;\n    text-align: left;\n}\n\n.product-text-info span {\n    font-size: 14px;\n    font-weight: 500;\n    color: #333;\n    line-height: 1.4;\n    word-break: break-word;\n}\n.search-row .date-buttons {\n    display: flex;\n    gap: 5px;\n}\n.search-row .date-buttons button {\n    padding: 10px 15px;\n    border: 1px solid #ccc;\n    background-color: #f1f1f1;\n    border-radius: 5px;\n    cursor: pointer;\n}\n.search-row .date-buttons button.active {\n    border-color: #e84118;\n    color: #e84118;\n    background-color: white;\n}\n.checkbox-group {\n    display: flex;\n    gap: 20px;\n    align-items: center;\n}\n.checkbox-group label {\n    width: auto;\n    font-weight: normal;\n    display: flex;\n    align-items: center;\n    gap: 5px;\n}\n\n.status-buttons {\n    display: flex;\n    gap: 10px;\n    align-items: center;\n}\n\n.status-buttons button {\n    padding: 8px 16px;\n    border: 1px solid #ccc;\n    background-color: #f8f9fa;\n    border-radius: 5px;\n    cursor: pointer;\n    font-size: 14px;\n    font-weight: 500;\n    transition: all 0.3s ease;\n}\n\n.status-buttons button.active {\n    background-color: #E84100;\n    color: white;\n    border-color: #E84100;\n}\n\n.status-buttons button:hover {\n    background-color: #e9ecef;\n    border-color: #adb5bd;\n}\n\n.status-buttons button.active:hover {\n    background-color: #d73502;\n    border-color: #d73502;\n}\n\n.product-info-cell {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    text-align: left;\n    padding: 10px;\n    background-color: #f8f9fa;\n    border-radius: 6px;\n    border: 1px solid #dee2e6;\n    gap: 15px;\n}\n\n.search-actions {\n    display: flex;\n    justify-content: center;\n    gap: 20px;\n    margin: 30px 0;\n}\n.search-actions button {\n    width: 350px;\n    padding: 15px;\n    border-radius: 5px;\n    font-size: 18px;\n    cursor: pointer;\n}\n.btn-search {\n    background-color: #e84118;\n    color: white;\n    border: none;\n}\n.btn-reset {\n    background-color: white;\n    color: #222;\n    border: 1px solid #222;\n}\n\n.quotation-list-container {\n    margin-top: 40px;\n}\n\n.list-header {\n    margin-bottom: 15px;\n}\n\n.list-header span {\n    font-weight: bold;\n}\n\n.quotation-table {\n    width: 100%;\n    border-collapse: collapse;\n    border-top: 2px solid #222;\n}\n\n.quotation-table th, .quotation-table td {\n    padding: 20px;\n    text-align: center;\n    border-bottom: 1px solid #eee;\n}\n\n.quotation-table th {\n    background-color: #f9f9f9;\n}\n\n.quotation-table .product-cell {\n    display: flex;\n    align-items: center;\n    gap: 15px;\n    justify-content: flex-start;\n    text-align: left;\n}\n\n.quotation-table .product-cell img {\n    width: 78px;\n    height: 42px;\n}\n\n.quotation-table {\n    width: 100%;\n    border-collapse: collapse;\n    border-top: 2px solid #333;\n    cursor: pointer;\n}\n\n.quotation-table th,\n.quotation-table td {\n    text-align: center;\n    padding: 15px 10px;\n    border-bottom: 1px solid #ddd;\n    vertical-align: middle;\n}\n\n.quotation-table th {\n    font-weight: bold;\n    background-color: #f8f9fa;\n}\n\n.quotation-table th:nth-child(1) { width: 60px; }\n.quotation-table th:nth-child(2) { width: 200px; }\n.quotation-table th:nth-child(3) { width: auto; min-width: 350px; }\n.quotation-table th:nth-child(4) { width: 100px; }\n.quotation-table th:nth-child(5) { width: 120px; }\n\n.quotation-table tr:hover {\n    background-color: #f8f9fa;\n}\n\n.page-actions {\n    display: flex;\n    justify-content: center;\n    gap: 20px;\n    margin-top: 50px;\n    border-top: 1px solid #222;\n    padding-top: 40px;\n}\n\n.page-actions button {\n    width: 350px;\n    padding: 15px;\n    border-radius: 5px;\n    font-size: 18px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n}\n\n.btn-secondary {\n    background-color: #222;\n    color: white;\n    border: none;\n}\n\n.btn-primary {\n    background-color: #e84118;\n    color: white;\n    border: none;\n}\n\n.arrow-icon {\n    font-size: 16px;\n    font-weight: bold;\n}\n\n/* Tablet and smaller devices */\n@media (max-width: 1024px) {\n    .search-row {\n        flex-direction: column;\n        align-items: stretch;\n        gap: 10px;\n    }\n    .search-row label {\n        width: auto;\n        padding-left: 0;\n    }\n    .search-actions, .page-actions {\n        flex-direction: column;\n    }\n    .search-actions button, .page-actions button {\n        width: 100%;\n    }\n}\n\n/* Mobile devices */\n@media (max-width: 768px) {\n    .quotation-table thead {\n        display: none;\n    }\n\n    .quotation-table, .quotation-table tbody, .quotation-table tr, .quotation-table td {\n        display: block;\n        width: 100%;\n    }\n\n    .quotation-table tr {\n        margin-bottom: 15px;\n        border: 1px solid #ddd;\n        border-radius: 5px;\n        overflow: hidden;\n    }\n\n    .quotation-table td {\n        text-align: right;\n        padding-left: 50%;\n        position: relative;\n    }\n\n    .quotation-table td::before {\n        content: attr(data-label);\n        position: absolute;\n        left: 15px;\n        width: calc(50% - 30px);\n        padding-right: 10px;\n        white-space: nowrap;\n        text-align: left;\n        font-weight: bold;\n    }\n    \n    .quotation-table .product-cell {\n        justify-content: flex-end;\n    }\n\n    .quotation-table .product-cell img {\n        display: none; /* Hide image on smallest screens to save space */\n    }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
